import { render, staticRenderFns } from "./DimensionalInfo.vue?vue&type=template&id=55c13d64&scoped=true&"
import script from "./DimensionalInfo.vue?vue&type=script&lang=js&"
export * from "./DimensionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./DimensionalInfo.vue?vue&type=style&index=0&id=55c13d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c13d64",
  null
  
)

export default component.exports